import AdminWebsocket from './AdminWebsocket';

class ComponentUninstallClient extends AdminWebsocket {
	connect() {
		return super.connect('/system/uninstall');
	}

	start(componentName) {
		this.sendData('start', { componentName });
	}

	onStatus(listener) {
		this.onData('status', listener);
	}

	unregisterEventListeners() {
		super.unregisterEventListeners();
		this.onStatus(null);
	}
}

export default ComponentUninstallClient;
